import { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";

export function useCanShowCcmsMemberLookup(): boolean {
  return useHasRoles([ROLE.GLOBAL_ADMIN, ROLE.SECTION_STAFF, ROLE.HQ_STAFF]);
}
